import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import VerticalTabs from "./VerticalTabs";
import BasicInformation from "./BasicInformation";
import {Person} from "../../services/interface/query/person";
import {useFindPersonBasicData} from "../../services/apis/apiPerson";
import Observations from "../components/observations";

function Dashboard() {
    const {personIdentification} = useParams();
    const {
        mutate: getPersonBasicData,
        error: errorPersonBasicData,
        data: successPersonBasicData,
        isPending: loadingPersonBasicData
    } = useFindPersonBasicData()

    const [openCollapse, setOpenCollapse] = React.useState(true);
    const [person, setPerson] = useState<Person | undefined>()
    const [personSpouse, setPersonSpouse] = useState<Person | undefined>()

    useEffect(() => {
        if (personIdentification) {
            setPerson(undefined)
            getPersonBasicData({identifier: personIdentification})
        }
    }, [personIdentification]);

    useEffect(() => {
        if (successPersonBasicData && successPersonBasicData?.identification === personIdentification) {
            setPerson(successPersonBasicData)
            setPersonSpouse(undefined)
            if (successPersonBasicData.identificationSpouse) {
                getPersonBasicData({identifier: successPersonBasicData.identificationSpouse})
            }
        } else if(successPersonBasicData && successPersonBasicData.identification === person?.identificationSpouse) {
            setPersonSpouse(successPersonBasicData)
        }
    }, [successPersonBasicData]);

    useEffect(() => {
        if (errorPersonBasicData) {

        }
    }, [errorPersonBasicData]);

    return(
        <div className={'max-w-[1200px] mx-auto min-h-[80vh] flex flex-col gap-5'}>
            <BasicInformation {...{openCollapse, setOpenCollapse, person, personSpouse, loadingPersonBasicData}}/>
            {/*{person && <Observations identification={person?.identification}/>}*/}
            <VerticalTabs loading={loadingPersonBasicData} {...{setOpenCollapse, person}}/>
        </div>
    )
}

export default Dashboard
